export const setLocalStorage = (name, value) => {
  window.localStorage.setItem(
    name, JSON.stringify(value)
  )
}
